import { render, staticRenderFns } from "./AboutTicket.vue?vue&type=template&id=4d004562&"
import script from "./AboutTicket.vue?vue&type=script&lang=ts&"
export * from "./AboutTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports